import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-28">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm text-[#5b80ff] hover:text-white transition mb-10"
          data-testid="back-home-link"
        >
          <ArrowLeft size={16} /> Back to home
        </Link>
        <p className="text-[11px] uppercase tracking-[0.3em] text-[#1440E1] font-semibold mb-4">
          Legal
        </p>
        <h1
          className="text-white leading-[1.05] tracking-tight mb-8 font-extrabold"
          style={{ fontFamily: '"Arial Black", Arial, sans-serif', fontSize: "clamp(38px, 5vw, 60px)" }}
          data-testid="privacy-heading"
        >
          Privacy Policy
        </h1>
        <p className="text-white/55 text-sm mb-12">Last updated: February 2026</p>

        <div className="space-y-8 text-white/80 leading-relaxed">
          <Section title="1. Information We Collect">
            Knight Media Group (&ldquo;KMG&rdquo;, &ldquo;we&rdquo;, or &ldquo;us&rdquo;) collects information you provide
            directly to us — including name, email, phone number, and any
            project details shared through our contact form, Bloom intake form,
            or scheduling tool. We also collect basic analytics data (pages
            viewed, device type, referral source) to improve site performance.
          </Section>
          <Section title="2. How We Use Your Information">
            We use the information you provide to respond to inquiries, deliver
            services we&rsquo;ve been engaged for, send relevant updates about
            your engagement, and improve our marketing and creative work. We do
            not sell your personal information to third parties.
          </Section>
          <Section title="3. Cookies & Analytics">
            We may use cookies and analytics tools (e.g., Google Analytics,
            Meta Pixel) to understand how visitors use our site. You can disable
            cookies through your browser settings; some features may not work
            without them.
          </Section>
          <Section title="4. Data Sharing">
            We share information only with service providers who help us run our
            business (hosting, scheduling, CRM, email) and only as needed to
            deliver our services. All providers are bound by confidentiality.
          </Section>
          <Section title="5. Data Security">
            We use industry-standard measures to protect your data. No
            transmission over the internet is 100% secure, but we work hard to
            keep your information safe.
          </Section>
          <Section title="6. Your Rights">
            You may request access, correction, or deletion of your personal
            information at any time by emailing
            {" "}<a href="mailto:damon.knight@knightmediagroup.com" className="text-[#5b80ff] hover:underline">damon.knight@knightmediagroup.com</a>.
          </Section>
          <Section title="7. Contact">
            Knight Media Group &mdash; 8465 Colerain Ave., Cincinnati, Ohio
            45239. Phone: 1(513)840-4087.
          </Section>
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section>
      <h2
        className="text-white text-xl sm:text-2xl mb-3"
        style={{ fontFamily: '"Arial Black", Arial, sans-serif' }}
      >
        {title}
      </h2>
      <p className="text-white/75 text-base">{children}</p>
    </section>
  );
}
